import { Order } from '../../services/exports/Interfaces';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import CustomButton from '../buttons/CustomButton';
import useAppMethods from '../../hooks/utility/useAppMethods';
import collect from 'collect.js';
import classnames from 'classnames';
import useAuth from '../../hooks/global/useAuth';
import useDeepRef from '../../hooks/utility/useDeepRef';

interface Props {
  order: Order;
  onCashbackClaimed: () => void;
  classes: {
    container?: string;
    button?: string;
  };
}

export default function ClaimOrderCashback({ order, onCashbackClaimed, classes }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Cashback:ClaimOrderCashback' });

  const { isGuest } = useAuth();
  const { toggleLoginModal } = useAppMethods();
  const { formatPointsAsMoney } = useCashbackProgram();

  const isGuestRef = useDeepRef(isGuest);

  const cashback = useMemo(
    () => +collect(order.cashback_account_operations).where('is_claimed', false).sum('value'),
    [order.cashback_account_operations],
  );

  return (
    isGuest &&
    cashback > 0 && (
      <div className={classes?.container}>
        <p className="font-medium text-sm">
          {t('text', {
            points: cashback,
            amount: formatPointsAsMoney(cashback),
          })}
        </p>
        <CustomButton
          title={t('button')}
          className={classnames('mt-sm !w-fit px-xl', classes?.button)}
          onClick={() =>
            toggleLoginModal({
              openModal: true,
              isStatic: true,
              initialPhoneNumber: order.customer_phone_number,
              onCloseRedirect: () => (isGuestRef.current ? null : onCashbackClaimed()),
            })
          }
        />
      </div>
    )
  );
}
